var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74401 2.66602L6.31601 9.33268H23.0173L21.588 2.66602H7.74401Z",
    fill: "#2859C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 0H5.58933L5.36267 1.05333L3.58933 9.33333H0V21.3333H29.3333V9.33333H25.744L23.9707 1.05333L23.744 0H6.66667ZM23.0173 9.33333L21.5893 2.66667H7.744L6.316 9.33333H23.0173Z",
    fill: "#8FBFFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16.6667H8V14H4V16.6667ZM25.3333 14H21.3333V16.6667H25.3333V14ZM4 21.3333V25.3333H6.66667V21.3333H4ZM22.6667 21.3333V25.3333H25.3333V21.3333H22.6667Z",
    fill: "#2859C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.7d28e38238a6b3950a538e449c62c3a7.svg";
export { ForwardRef as ReactComponent };